import { render, staticRenderFns } from "./AcessoRealtec.html?vue&type=template&id=67e63fd8&"
import script from "./AcessoRealtec.vue?vue&type=script&lang=js&"
export * from "./AcessoRealtec.vue?vue&type=script&lang=js&"
import style0 from "./AcessoRealtec.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports